export default {
  "pwaDeviceList.thead.id": "ID",
  "pwaDeviceList.thead.bindSite": "绑定站点",
  "pwaDeviceList.thead.channel": "渠道",
  "pwaDeviceList.thead.host": "主机",
  "pwaDeviceList.thead.fullUrl": "完整URL",
  "pwaDeviceList.thead.endpoint": "端点",
  "pwaDeviceList.thead.createTime": "创建时间",
  "pwaDeviceList.thead.modifyTime": "修改时间",
  "pwaDeviceList.thead.action": "操作",
  "pwaDeviceList.title": "PWA设备列表",
};